module.exports = __webpack_public_path__ + "static/rad1-ec3d53104e40a745655b77203164cd7b.jpg";